/**
 * Reusable CSV export utility.
 * Uses PapaParse when available on window, otherwise falls back to basic serialisation.
 */

function downloadCSV(filename, csvContent) {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
}

function basicCSVExport(filename, data) {
  if (!data || !data.length) return;

  const headers = Object.keys(data[0]);
  const csvContent = [
    headers.join(','),
    ...data.map(row =>
      headers.map(header => {
        const value = row[header] ?? '';
        const str = String(value);
        return str.includes(',') || str.includes('"') || str.includes('\n')
          ? `"${str.replace(/"/g, '""')}"`
          : str;
      }).join(',')
    )
  ].join('\n');

  downloadCSV(filename, csvContent);
}

export function exportToCSV(filename, data) {
  if (!data || !data.length) return;

  if (typeof window.Papa !== 'undefined') {
    const csv = window.Papa.unparse(data);
    downloadCSV(filename, csv);
    return;
  }

  basicCSVExport(filename, data);
}
